import { useSyncExternalStore } from 'react';
import { isDownloadInFlight, subscribeToDownloads } from '../api/receipt.api';

/**
 * Whether the PDF at `path` (from `receiptDocumentPath`) is being fetched, for a button's
 * "Preparing…" state. Every button for the same document shows it.
 */
export const useDownloadInFlight = (path: string): boolean =>
  useSyncExternalStore(subscribeToDownloads, () => isDownloadInFlight(path));
